import { nextTick } from 'vue'
import { api } from '@/helpers/api'

const URLS = {
    xhr: {
        fetch: {
            media: {
                artist: '/api/profile/v1/user-profile/artist-medias',
                venue: '/api/profile/v1/user-profile/venue-medias'
            }
        },
        mutate: {
            media: '/api/profile/update-media/artist',
            avatar: '/api/profile/update-avatar/artist',
            avatarUpdateExistingMedia: '/api/profile/check-main-media',
            audio: '/api/profile/update-audio'
        }
    }
}
export const useMediaUpload = () => {
    async function updateProfileAvatar(medias, indx, id, load) {
        if (!medias.length) return Promise.resolve(true)

        await nextTick()
        const selectedAvatar = medias[indx]

        try {
            if (load.value !== null) load.value = true
            await api({
                method: 'post',
                url: `${URLS.xhr.mutate.avatar}/${id}`,
                data: _prepMediaData([selectedAvatar], true, indx)
            })
            return true
        } catch {
            return false
        } finally {
            if (load.value !== null) load.value = false
        }
        /*
        NOTE: previous implementation may need to keep to update avatar from existing uploaded data
        if (selectedAvatar.id) {
            try {
                if (load.value !== null) load.value = true
                await api({
                    method: 'post',
                    url: `${URLS.xhr.mutate.avatarUpdateExistingMedia}/${id}/${role}`,
                    data: {
                        _method: 'PUT',
                        id: selectedAvatar.id
                    }
                })
                return true
            } catch {
                return false
            } finally {
                if (load.value !== null) load.value = false
            }
        } else {
            try {
                if (load.value !== null) load.value = true
                await api({
                    method: 'post',
                    url: `${URLS.xhr.mutate.avatar}/${id}/${role}`,
                    data: _prepMediaData([selectedAvatar], true, indx)
                })
                return true
            } catch {
                return false
            } finally {
                if (load.value !== null) load.value = false
            }
        } */
    }
    async function updateProfileMedia(data, indx, id, load) {
        if (!data.length) return Promise.resolve(true)

        data = _prepMediaData(data, false, indx)
        if (!data.getAll('files[]').length) return Promise.resolve(true)

        try {
            if (load.value !== null) load.value = true
            await api({
                method: 'post',
                url: `${URLS.xhr.mutate.media}/${id}`,
                data
            })
            return true
        } catch {
            return false
        } finally {
            if (load.value !== null) load.value = false
        }
    }
    function _prepMediaData(data, avatarUpload, indx) {
        if (avatarUpload && !(data[0] instanceof File) && data[0].id) {
            return {
                avatar_id: data[0].id,
                _method: 'PUT'
            }
        }

        let formData = new FormData()

        for (let i = 0; i < data.length; i++) {
            if (!avatarUpload && i === indx) continue

            if (data[i] instanceof File) {
                formData.append('files[]', data[i])
            }
        }

        formData.append('_method', 'PUT')
        return formData
    }

    async function updateArtistAudio(data, id, load) {
        if (!data.length) return Promise.resolve(true)

        try {
            if (load.value !== null) load.value = true
            await api({
                method: 'post',
                url: `${URLS.xhr.mutate.audio}/${id}`,
                data: _prepAudioData(data)
            })
            return true
        } catch {
            return false
        } finally {
            if (load.value !== null) load.value = false
        }
    }
    function _prepAudioData(data) {
        let formData = new FormData()
        let order = {}
        let orderName

        for (let i = 0; i < data.length; i++) {
            if (data[i] instanceof File) {
                orderName = data[i].name.split('.').slice(0, -1).join('.')
                formData.append('audios[]', data[i])
            } else {
                orderName = data[i].name_file
            }

            order = {
                ...order,
                [orderName]: i
            }
        }

        formData.append('order', JSON.stringify(order))
        formData.append('_method', 'PUT')

        return formData
    }

    return {
        updateProfileAvatar,
        updateProfileMedia,
        updateArtistAudio
    }
}
